import { useState, useMemo } from "react";

import { useAlgolia, useRouter, useSettings, useUsers } from "hooks";
import { ALL_CONTENT_TYPES } from "enums/contentTypes";
import MetaTags from "components/MetaTags";
import AlgoliaSearchWrapper from "components/AlgoliaSearchWrapper";
import MainTitle from "components/MainTitle";
import View from "pages/Search/components/View";

const Search = () => {
  const {
    query: { term: linkSearchTerm },
    location,
  } = useRouter();
  const {
    settings: { algolia },
  } = useSettings();
  const { currentUserLoaded } = useUsers();
  const { createInitialUiStateFromSingle, filterValues, hasFacetFilterValues } = useAlgolia();
  const [searchTerm, setSearchTerm] = useState(linkSearchTerm || "");
  const description = `Search results for personalized ${searchTerm} eCards from JibJab.`;
  const { contentTypeFiltersForPath, numberOfPeopleFiltersForPath, sortFilterSelectedForPath } = filterValues(
    location.pathname,
  );
  const defaultFilters = useMemo(() => [ALL_CONTENT_TYPES.flatMap((item) => item.value)], []);
  const hasFacetFilters = hasFacetFilterValues(location.pathname);
  const initialUiState = useMemo(() => {
    if (!currentUserLoaded) return undefined;
    const facetFilters = hasFacetFilters
      ? [...contentTypeFiltersForPath, ...numberOfPeopleFiltersForPath]
      : defaultFilters;

    return createInitialUiStateFromSingle(algolia.indexName, {
      query: {
        query: searchTerm,
        facetFilters,
      },
      sortBy: sortFilterSelectedForPath,
    });
  }, [currentUserLoaded, createInitialUiStateFromSingle]);

  return (
    <>
      {!initialUiState ? null : (
        <AlgoliaSearchWrapper proxy={false} context="search" initialUiState={initialUiState}>
          <View
            initialUiState={initialUiState[algolia.indexName]}
            searchTerm={searchTerm}
            setSearchTerm={setSearchTerm}
            defaultFilters={defaultFilters}
            defaultSortBy={algolia.indexName}
          />
        </AlgoliaSearchWrapper>
      )}
      <MainTitle
        title={`Funny eCards - Send Custom Greeting Cards Online w/ JibJab! - ${searchTerm} eCard Search Results`}
      />
      <MetaTags>
        <meta name="robots" content="noindex" />
        <meta name="keywords" content={`${searchTerm}, eCards, funny, search`} />
        <meta name="description" content={description} />
        <meta name="og:title" content={`${searchTerm} eCard Search Results`} />
        <meta name="og:description" content={description} />
      </MetaTags>
    </>
  );
};

export default Search;
